import ClubShipDate from './ClubShipDate';

const MobileToggleSummary = (props) => {
  const { onToggleMobile, clubPackage, clubMemberShipment } = props;
  const toggleMobileSummary = (e) => {
    e.preventDefault();
    onToggleMobile();
  };
  return (
    <div className="c7-checkout-template__toggle">
      <div onClick={toggleMobileSummary}>
        <ClubShipDate
          clubPackage={clubPackage}
          clubMemberShipment={clubMemberShipment}
        />
      </div>
    </div>
  );
};
export default MobileToggleSummary;
